import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import { formatPrice } from 'helpers/helpers'
import { FormattedMessage } from 'react-intl'
import { FamilyPackageSummaryWrapper } from './styles'

interface FamilyPackageSummaryInterface {
    numberOfDays: number
    price: number
}

export const FamilyPackageSummary = ({
    numberOfDays,
    price,
}: FamilyPackageSummaryInterface) => (
    <FamilyPackageSummaryWrapper isFullWidth>
        <Box
            direction="row"
            align="flex-end"
            justify="space-between"
            isFullWidth
            pt={16}
        >
            <Box direction="row">
                <Text variant="body" color="grayscale_900">
                    <FormattedMessage
                        id="package.family.package_price"
                        defaultMessage="Cena pakietu"
                    />
                </Text>
                {numberOfDays > 1 && (
                    <Text variant="body" color="grayscale_800" ml={4}>
                        (
                        <FormattedMessage
                            id="global.plurals.days"
                            defaultMessage="{days, plural, few {# dni} many {# dni} other {# dnia}}"
                            values={{
                                days: numberOfDays,
                            }}
                        />
                        )
                    </Text>
                )}
                <Text variant="body" color="grayscale_900">
                    :
                </Text>
            </Box>
            <Box direction="row" align="baseline" gap={4}>
                <Text variant="heading2" color="secondary_500">
                    {formatPrice(price)}
                </Text>
                <Text variant="body" color="secondary_500">
                    PLN
                </Text>
            </Box>
        </Box>
    </FamilyPackageSummaryWrapper>
)
